import React from 'react';
import GraderShell from '../features/grader/components/GraderShell';

const CompetitionReport = () => {
  return <GraderShell />;
};

export default CompetitionReport;
